import { useMutation } from '@tanstack/react-query';
import type { AgentApiCandidateInterviewLogsShow } from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';
import type { CandidateProfileInterviewLogsRequest } from '../types/CandidateProfile';

export default function usePostCandidateInterviewLogs() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: ({
      candidateProfileId,
      title,
      interviewed_at,
      organization_user_id,
      custom_data,
    }: CandidateProfileInterviewLogsRequest) =>
      fetchJson<AgentApiCandidateInterviewLogsShow>(
        `/agent/api/candidate_profiles/${candidateProfileId}/candidate_interview_logs`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({ title, interviewed_at, organization_user_id, custom_data }),
        }
      ),
  });
}
